export const SET_CENTROS_CUSTOS = 'centrosCustos';
export const SET_SOLICITANTES = 'solicitantes';
export const SET_PRODUTO = 'produto';
export const SET_PROJETO = 'projeto';
export const SET_SEARCH_TEXT = 'searchText';
export const SET_EMPRESA = 'empresa';
export const SET_GRUPO = 'grupo';
